function PatternList() {

    return [{
        id: 0,
        title: 'Sequence 1',
        noteCount: 16,
        patternList: [
            {
                sample: 'basedrum808',
                notes:[[0, 2, 4, 6, 8, 10, 12, 14],[1,3,5,7,9,11,13,15]],
            },
            {
                sample: 'snaredrum808',
                notes:[[2, 4, 10, 12, 15]],
            },
            {
                sample: 'openhh808',
                notes:[[8]],
            },
            {
                sample: 'closedhh808',
                notes:[[0, 3, 4, 7, 8, 12, 13],[0, 4, 8, 12]],
            },
            {
                sample: 'lowconga808',
                notes:[[2,5,6]],
            },
            {
                sample: 'middleconga808',
                notes:[[7,11]],
            },
            {
                sample: 'highconga808',
                notes:[[8,13]],
            }
        ]
    },]
}
export default PatternList;